<template>
    <div>
        <div class="col-md-12 pt-3 centre_sm_none backs" v-show="!showDetail">
            <p class="myTitle">All orders</p>

            <div class="col-md-12 mypaddings" v-show='IsPC()'>
                <ul class="col-md-12 myHeard clearfix" >
                    <li class="col-md-4">Name</li>
                    <li class="col-md-2">Order number</li>
                    <li class="col-md-2">Time of payment</li>
                    <li class="col-md-2">Mode of payment</li>
                    <li class="col-md-2">Amount</li>
                </ul>
            </div>

            <div class=" row nano video_breviary m-0 wenzlist has-scrollbar">
                <div class="nano-content" id="home_left_list">
                    <ul class="list-unstyled" style="padding-bottom: 50px;">
                        <li v-for="homeList in homeLists" class="clearfix">
                            <div class="name col-md-4" v-if='homeList.product_info.thumb!=""' @click="gotodetail(homeList.order_type, homeList.product_info)">
                                <img :src="homeList.product_info.thumb" alt="" />
                                <!--<img :src="homeList.product_info.thumb" alt=""  width="45px" height="60px"/>-->
                                <p>{{homeList.product_info.title}}</p>
                            </div>
                            <div class="name col-md-4" v-if='homeList.product_info.thumb==""'  @click="gotodetail(homeList.order_type, homeList.product_info)">
                                <p>{{homeList.product_info.title}}</p>
                            </div>
                            <div class="deal col-md-2">
                                <span v-show='!IsPC()'>Order number：</span>{{homeList.out_trade_no}}
                            </div>
                            <div class="time col-md-2">
                                <span v-show='!IsPC()'>Time of payment：</span> {{homeList.buy_date}}
                            </div>
                            <div class="type col-md-2">
                                <span v-show='!IsPC()'>Mode of payment：</span> {{(homeList.pay_type == 'alipay') ? 'Alipay' : 'WeChat' }}
                            </div>
                            <div class="money col-md-2">
                                <span v-show='!IsPC()'>Amount：</span> ${{homeList.total_fee}}
                            </div>
                        </li>
                        <p class="text-center" v-if="loadShow"><i class="fa fa-spinner fa-pulse fa-2x mt-3"></i></p>
                    </ul>
                    <div v-if="homeLists.length ==0&&!loadShow" class="nodata text-center">
                        <img src="../../../assets/images/silkRoadBase/no_data.png" class="mt100" alt="" />
                        <p class="text-center p-2">loading</p>
                    </div>
                </div>
            </div>

        </div>

        <div class="col-md-12 pt-3 centre_sm_none backs" v-show="showDetail">
        <p class="myTitle">My orders <span class="myBtn" @click='goback()'>Back</span></p>
            <div class="embed-responsive row video_breviary m-0 wenzlist has-scrollbar h-100" v-if="activeOrderType == 'issue_page'">
                <iframe class="embed-responsive-item" name="" :src="'https://img.imsilkroad.com/pdf/web/viewer.html?file='+encodeURIComponent(this.detailes.pdf)"></iframe>
            </div>
            <div class="centre_content nano" id="centre_contents" v-if="activeOrderType == 'article'">
            <span class="nano-content p-4" >
            <h1 class="information_article_headline">{{product.title}}</h1>
            <p class="information_article_info">
            <span class="mr-2">{{product.published}}</span>
            <span v-if="product.author && product.author.length > 0">Author：<span class="mr-2" v-for="(value,index) in product.author">{{value}}</span>
                                        </span>
            <span v-if="product.source">Sources：{{product.source}}</span>
            </p>
            <div class="information_article_abstract rounded">
            <p>
                Abstract：{{product.description}}
            </p>
            </div>
            <!-- 文章 -->
            <div class="information_article_details text-indent2" v-if="product.appid == 1" v-html="product.content"></div>
            <!-- 组图 -->
            <div class="information_article_details text-indent2" v-if="product.appid == 2">
            <div v-for="item in JSON.parse(product.content)">
                <p>
                    <img class="img-thumbnail" :src="item.url"/>
                </p>
                <p v-html="item.description"></p>
            </div>
            </div>
            <!-- 视频 -->
            <div class="information_article_details text-indent2" v-if="product.appid == 4">
            <video id="my-video" class="video-js" controls preload="auto" style="width: 100%;" height="400" :poster="product.content" data-setup="{}">
            <source ref="video" type="video/mp4">
            <!--<p class="vjs-no-js"> To view this video please enable JavaScript, and consider upgrading to a web browser that
            <a href="http://videojs.com/html5-video-support/" target="_blank">supports HTML5 video</a>
            </p>-->
            </video>
            </div>
            <span class="f12 d-block mb-2" v-if="product.editor">Editor：{{product.editor}}</span>
            </span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "allDeal",
        data() {
            return {
                homeLists:[],
                loadShow: false,
                pages: 1,
                total_pages: 1,
                page_size: 10,
                showDetail: false,
                product : {},
                activeOrderType : ''
            }
        },
        mounted() {
            this.getData()
            document.getElementById('home_left_list').addEventListener('scroll', this.Scrolles);
                this.load();
        },
        methods: {
            goback() {
              this.showDetail = false;
            },
            gotodetail(type, product_info){
                this.activeOrderType = type;
                this.showDetail = true;
                this.product = product_info;
                this.$nextTick(function () {
                    this.load();
                })
            },
            getData(){
              var that=this;
              var params={"current_page":this.pages,"page_size":this.page_size};
                this.$axios.post('/api/pc/orderlist',params).then(data => {
                    if (data.data.state) {
                        that.homeLists=data.data.data.data;
                        that.total_pages=Math.ceil(data.data.data.total/10);
                    }
                })
            },
            Scrolles() {
                var top = document.getElementById('home_left_list').scrollTop; // 滚动条到上面的距离
                var client = document.getElementById('home_left_list').clientHeight; // 可视区域的高度
                var all = document.getElementById('home_left_list').scrollHeight; // 总高度
                if (((all - 20) < (top + client)) && !this.loadShow) {
                    this.pages++;
                    if (this.pages > this.total_pages) {
                        return;
                    }
                    let that = this;
                    that.loadShow = true;
                    this.$axios.post('/api/pc/orderlist', {
                        current_page: that.pages,
                        page_size:that.page_size
                    }).then(data => {
                        if (data.data.state) {
                            var homeListes = data.data.data.data;
                            JSON.stringify(homeListes);
                            var new_homeLists = that.homeLists.concat(homeListes);
                            that.homeLists = new_homeLists;
                            that.loadShow = false;
                        }
                    })
                }
            },
        }
    }
</script>

<style scoped>
    .mypadding{
        padding: 20px 30px;
    }
    .myTitle{
        background-color: white;
        height:62px;
        border-bottom: 1px solid #F5F6F7;
        text-align: left;
        font-size:18px;
        padding-left: 30px;
        margin-bottom: 0!important;
        font-family:PingFangSC-Medium;
        font-weight:500;
        color:rgba(0,0,0,1);
        line-height:64px;
    }
    .myHeard{
        /*height:50px;*/
        background:rgba(241,241,241,1);
        padding-right:0;
    }
    .mypaddings{
        padding:20px 30px 0;
        background-color: white;
    }
    .information_article_details img{
        max-width: 100%;
        display: block;
        margin: 0 auto;
    }
    .myHeard li{
        text-align:center;
        line-height:50px;
        font-size:14px;
        font-family:PingFangSC-Medium;
        font-weight:500;
        float:left;
        border-right: 1px solid #f5f6f7;
        color:rgba(74,74,74,1);
    }
    .centre_content{
        box-shadow:none
    }
    ul{
        margin-bottom:0
    }
    #home_left_list ul{
        margin:0 30px;
    }
    #home_left_list li{
        border:1px solid rgba(245,246,247,1);
        margin-top:10px;
        padding:0 0 0 15px;
        display:flex;
        overflow:hidden;
        /*height:90px;*/
    }
    #home_left_list li div{
        float:left;
        text-align:center;
        padding: 15px 0;
        border-right: 1px solid #f5f6f7;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
    }
    .name{
        display:flex;
        justify-content: flex-start!important;
    }
    .name:hover{
        cursor: pointer;
    }
    .name img{
        width:80px;
        height:60px;
    }
    .name p{
        font-size:14px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(0,0,0,1);
        margin-left: 15px!important;
        /*line-height:60px;*/
        text-align:left;
    }
    .deal,.time,.type{
        font-size:12px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(89,89,89,1);
        /*line-height:60px;*/
    }
    .deal{
        word-break: break-all;
    }
    .money{
        font-size:14px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(32,142,255,1);
        /*line-height:60px;*/
    }
    p{
        margin-bottom:0!important;
    }
    .backs{
        /*background: #fff;*/
        box-shadow: 0 4px 10px 0 rgba(0,0,0,0.10);
    }
    .wenzlist{
        background: #fff;
    }
    .over{
        overflow-x:auto
    }
    .myBtn{
        width:60px;
        height:30px;
        display:block;
        position:absolute;
        top:31px;
        right:60px;
        font-size:12px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(133,144,166,1);
        line-height:30px;
        text-align:center;
        background:rgba(242,243,244,1);
        border-radius:20px;
    }
    .myBtn:hover{
        cursor:pointer;
    }
</style>
